import gql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface CSVVariables {
  orderBy: string
  where: any
}

interface IPayload {
  createWorkplaceGroupExport: { export: { url: string } }
}

const mutateHandler = handleFetchResult<IPayload, string>({
  handler: (data) => data.createWorkplaceGroupExport.export.url,
  name: 'CSV',
})

export default function csv({ orderBy, where }: CSVVariables): Promise<string> {
  return client.gql
    .mutate({ mutation, variables: { input: { orderBy, where } } })
    .then(mutateHandler)
}

const mutation = gql`
  mutation CreateWorkplaceGroupExport($input: CreateWorkplaceGroupExportInput!) {
    createWorkplaceGroupExport(input: $input) {
      export {
        url
        name
      }
    }
  }
`
